import { store } from '@/state/store';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO_IMAGE_META__base } from '@shared/dto/+image/meta/_base/DTO_IMAGE_META__base';

export function INIT_EXTENSION__meta_image_use_client() {
  DTO_IMAGE_META__base.prototype.images__try_load = images__try_load;
}

async function images__try_load(this: DTO_IMAGE_META__base) {
  let { images_hashes_to_load } = this;

  let images_map_all = store.getState().slice_images.images_map;

  let images_map_meta = new Map<string, DTO__image_asset>();

  for (let hash_sha256 of images_hashes_to_load) {
    if (!images_map_all.has(hash_sha256)) continue;

    let image = images_map_all.get_or_assert(hash_sha256);

    images_map_meta.set(hash_sha256, image);
  }

  this.on_images_loaded(images_map_meta);
}
